<template>
    <v-card>
        <v-card-text>
            <v-form
                ref="form">
                <v-text-field
                    autofocus
                    :label="$t('payment_code')"
                    hide-details="auto"
                    v-model="form.payment_code"
                    append-icon="mdi-pound">
                </v-text-field>

                <customer-search
                    :dense="false"
                    label="Customer"
                    hide-details
                    item-value="id"
                    item-text="display_name"
                    v-model="form.customer_id">
                </customer-search>

                <v-menu
                    ref="menu_date_from"
                    v-model="menu.date_from"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px">
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="form.date_from"
                            :rules="rules.date_from"
                            :label="$t('date_from')"
                            append-icon="mdi-calendar"
                            hide-details="auto"
                            readonly
                            v-bind="attrs"
                            v-on="on">
                        </v-text-field>
                    </template>
                    <v-date-picker v-model="form.date_from" @input="menu.date_from = false" no-title scrollable></v-date-picker>
                </v-menu>

                <v-menu
                    ref="menu_date_to"
                    v-model="menu.date_to"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px">
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="form.date_to"
                            :rules="rules.date_to"
                            :label="$t('date_to')"
                            append-icon="mdi-calendar"
                            hide-details="auto"
                            readonly
                            v-bind="attrs"
                            v-on="on">
                        </v-text-field>
                    </template>
                    <v-date-picker :min="form.date_from" v-model="form.date_to" @input="menu.date_to = false" no-title scrollable></v-date-picker>
                </v-menu>

                <user-search
                    :dense="false"
                    label="Created By"
                    hide-details="auto"
                    item-value="id"
                    item-text="name"
                    v-model="form.user_id"
                    append-icon="mdi-account">>
                </user-search>

                <v-text-field
                    :label="$t('payment_type')"
                    hide-details="auto"
                    v-model="form.payment_mode"
                    append-icon="mdi-shape">
                </v-text-field>

                <v-text-field
                    :label="$t('amount')"
                    hide-details="auto"
                    v-model="form.amount"
                    append-icon="mdi-cash">
                </v-text-field>

                <v-text-field
                    :label="$t('description')"
                    hide-details="auto"
                    v-model="form.description"
                    append-icon="mdi-text">
                </v-text-field>

                <v-select

                    label="State"
                    v-model="form.state"
                    :items="states"
                    clearable
                >
                </v-select>
            </v-form>
        </v-card-text>
        <v-card-actions>
            <v-btn
                text
                @click="submit"
                :loading="loading"
                :disabled="loading">
                {{ $t("search") }}
            </v-btn>
            <v-btn text @click="resetForm">
                {{ $t("reset") }}
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import CustomerSearch from '../searchComponents/CustomerSearch';
import UserSearch from '../searchComponents/UserSearch';

export default {
    name: "PaymentSearchMenu",
    components: {
        CustomerSearch,
        UserSearch
    },
    props: {
        loading: {
            required: false,
            type: Boolean
        },
        value: Object
    },
    watch: {
        form: {
            deep: true,
            handler(form) {
                this.$emit("input", {...form})
            }
        }
    },
    data() {
        return {
            display: false,
            form: {},
            menu: {
                date_from: false,
                date_to: false
            },
            rules: {
                date_from: [

                ],
                date_to: [

                ]
            },
            states: [
                { text: "Draft", value: "DRAFT" },
                { text: "Posted", value: "POSTED" },
            ],
        }
    },
    methods: {
        submit() {
            this.$emit("submit", this.form);
        },
        resetForm() {
            this.$refs.form.reset();
            this.form.customer_id = null;
        }
    },
    created() {
        if(this.value) {
            this.form = {...this.value};
        }
    }
}
</script>